import { generateClient } from 'aws-amplify/api';
import { fetchUserAttributes } from 'aws-amplify/auth';
import type { Schema } from "../../amplify/data/resource";
import I18nTextUtils from './i18n/I18nTextUtils';

interface SendEmailParams {
  senderCategory: string;
  topic: string;
  subject: string;
  body: string;
}

const client = generateClient<Schema>()


export class EmailUtils {
  static async sendEmail(params: SendEmailParams): Promise<{ success: boolean; messageId?: string; error?: string }> {
    try {

      // Get current user's email and name
      const userAttributes = await fetchUserAttributes();
      const userEmail = userAttributes.email;
      const userName = userAttributes.nickname || userAttributes.name || 'Unknown User';

      if (!userEmail) {
        throw new Error('User email not found');
      }

      // Call the Lambda function via Amplify API
      const response = await client.queries.sendSupportEmail({
        senderCategory: params.senderCategory,
        topic: params.topic,
        subject: params.subject,
        body: params.body,
        userEmail: userEmail,
        userName: userName,
        currentLanguage: I18nTextUtils.getCurrentLanguage(),
      }, {
        authMode: 'userPool'
      });

      // Parse the response data JSON string
      let statusCode = null;
      let messageId = null;

      if (response.data) {
        try {
          const responseObj = JSON.parse(response.data);
          statusCode = responseObj.statusCode;
          
          // Parse the body string to get messageId
          if (responseObj.body) {
            const bodyObj = JSON.parse(responseObj.body);
            messageId = bodyObj.messageId;
          }
        } catch (e) {
          console.warn('Could not parse response JSON:', e);
        }
      }

      if (statusCode === 200) {
        console.debug('email lambda response (success):', response);
        return {
          success: true,
          messageId: messageId || "N/A",
        };
      } else {
        const errorResponse = {
          success: false,
          error: 'Failed to send email',
        };
        console.warn('Error response: ', errorResponse, '\nEmail Lambda response (failed):', response);
        return errorResponse;
      }
    } catch (error) {
      console.error('Error sending email:', error);
      return {
        success: false,
        error: 'Error sending email',
      };
    }
  }
} 